
<template>
  <!-- //? Componente que muestra un chat/comentarios de FO postventa integrado con la plataforma de webcentrix -->
  <div style="position: relative" class="comment-section-new">
    <template v-if="!getDetalles">
      <div>
        <!-- //* Loading hasta cargar los comentarios del chat  -->
        <div
          v-if="loading"
          :element-loading-text="textLoading"
          element-loading-spinner="el-icon-loading"
          class="comment-section"
          v-loading="loading"
        ></div>
        <div></div>
        <!-- //* Comentarios del chat -->
        <ul
          v-if="!loading"
          v-loading="subiendoImagen"
          class="comment-section"
          id="style-1"
          v-chat-scroll="{ always: false, smooth: false }"
        >

          <li
            v-for="m in messages"
            :key="m.id"
            :class="getClase(m.origen)"
          >
            <!-- //* Nombre del cliente y/o soporte -->
            <div class="info" v-if="m.origen != 'A'">
              <a v-if="m.origen == 'C'">{{ datos.nombre }}  <br> <span v-if="m.isMail">(respuesta enviada por correo electrónico)</span> </a>
              <a v-if="m.origen == 'F'">Farmaonline</a>
              <!-- //* Fecha y hora del mensaje -->
              <span>{{ $date(m.timestamp).format("DD/MM/YYYY HH:mm") }}</span>
            </div>
            <!-- //* Avatar del cliente y/o soporte  -->
            <a class="avatar"  v-if="m.origen != 'A'">
              <img
                :src="[
                  m.origen == 'C'
                    ? require('../assets/user.svg')
                    : require('../assets/fo.png'),
                ]"
                width="35"
                alt="Profile Avatar"
                title="Anie Silverston"
              />
            </a>
            <!-- //* Contenido del mensaje del cliente -->
            <!-- <p   v-if="m.origen =='C' && m.content != 'image' && !m.preview">{{m.content}}</p> -->
            <p   class="html"
              v-if=" m.content == 'image' && m.preview">
            <a

              :href="m.preview"
            
              target="_blank"
            >
              <img :src="m.preview" />
            </a>
            </p>
            <!-- <p class="html" v-if="m.content && m.content == 'image'" v-html="m.content"></p> -->
            <!-- //* Imagen/Mensaje enviado por el soporte -->
            <p class="html" v-if="m.content && m.content != 'image'" v-html="m.content"></p>
          
          </li>
        </ul>
      </div>
      <!-- v-if="this.datos.datos_reclamo[0].estado == 'A'" -->

      <div class="write-new" style="">
        <el-row :gutter="0">
          <el-col :md="19" :xs="19" :sm="19">
            <div style="">
              <el-input
                placeholder="Escriba su mensaje aquí"
                id="comment"
                type="textarea"
                :disabled="!nuevo"
                v-model="message"
                ref="msj"
                @keypress.enter.native="onMessageSubmitV2"
              ></el-input>
            </div>
          </el-col>

          <el-col :md="5" :xs="5" :sm="5">
            <el-button
              id="botones"
              class="upload"
              :type="colorBotones"
              @click="onMessageSubmitV2"
              :disabled="anularBoton()"
              >Enviar</el-button
            >
          </el-col>
          <el-col :md="24">
            <el-button
              size="mini"
              type="warning"
              class="btn-chat-opt"
              v-if="
                !datos.datos_reclamo || datos.datos_reclamo[0].motivo_id != 1
              "
              icon="el-icon-back"
              @click="regresar"
              :disabled="anularBoton()"
              >Regresar</el-button
            >
            <el-button
              size="mini"
              type="warning"
              class="btn-chat-opt"
              v-if="
                $isMobile() &&
                datos.datos_reclamo &&
                datos.datos_reclamo[0].motivo_id == 1
              "
              icon="el-icon-back"
              @click="regresarPedido"
              :disabled="anularBoton()"
              >Regresar</el-button
            >
            <el-upload
              class="upload-demo"
              :action="urlUploadImage"
              :data="dataMensaje"
              :show-file-list="false"
              :limit="5"
              :on-success="onImageSelectedV2"
              :before-upload="beforeAvatarUpload"
              style="float: left; z-index: 99"
            >
              <el-button
                slot="trigger"
                style="float: left"
                :type="colorBotones"
                class="btn-chat-opt"
                size="mini"
                icon="el-icon-picture-outline"
                >Imagen</el-button
              >
            </el-upload>
            <el-button
              size="mini"
              icon="el-icon-plus"
              type="danger"
              class="btn-chat-opt"
              v-if="datos.datos_reclamo"
              @click="getDetalles = true"
              :disabled="anularBoton()"
              >Detalle del reclamo</el-button
            >
          </el-col>
        </el-row>
      </div>
    </template>

    <template v-if="getDetalles && datos.datos_reclamo">
      <div class="table-detalles">
        <strong>Datos de su reclamo</strong>
        <table class="table">
          <tr>
            <td>Fecha de creación</td>
            <th>
              {{
                $date(datos.datos_reclamo[0].fecha_creacion.date).format(
                  "DD/MM/YYYY HH:mm"
                )
              }}
            </th>
          </tr>
          <tr>
            <td>Número de reclamo</td>
            <th>{{ datos.datos_reclamo[0].number_case }}</th>
          </tr>
          <tr>
            <td>Motivo</td>
            <th>{{ datos.datos_reclamo[0].motivo }}</th>
          </tr>
          <tr>
            <td>Estado</td>
            <th>
              {{ estados[datos.datos_reclamo[0].wc_status] || "Abierto" }}
            </th>
          </tr>
        </table>

        <el-button type="info" size="default" @click="getDetalles = false"
          >Regresar</el-button
        >
      </div>
    </template>
  </div>
</template>

<script>
// import { mapGetters, mapActions } from "vuex";

import { AUTOMATIC_MESSAGE, formatUrl } from "../helpers/helpers";
import { EventBus } from "@/event-bus.js";
import { baseUrl, HTTP, FILES_PATH } from "@/axios";

export default {
  name: "commentSection",
  props: ["datos"],
  data() {
    return {
      message: "",
      nuevo: true,

      getDetalles: false,
      subiendoImagen: false,
      messages: [],
      colorBotones: "danger",
      dataMensaje: {},
      datas: {},
      datosAux: {},
      imgBandera: true,
      inicio: false,
      inputImg: "",
      loading: false,
      loadingReclamo: false,
      numberCase: 0,
      productos: null,
      textLoading: "Cargando mensajes...",
      urlUploadImage: baseUrl + "/setMensaje",
      estados: {
        solved: "Resuelto",
        closed: "Cerrado",
        open: "Abierto",
        pending: "Pendiente",
        onhold: "Esperando su respuesta",
      },

      btnActivated: false,
      visible: true,
      origen: this.$route.name === "admin" ? "F" : "C",

      chatTitle: "Farmaonline",
      placeholder: "escriba su mensaje aquí",
      colors: {
        header: {
          bg: "#d30303",
          text: "#fff",
        },
        message: {
          others: {
            bg: "rgb(255 130 120 / 19%)",
            text: "#333",
          },
          myself: {
            bg: "#fb4141",
            text: "#fff",
          },
          messagesDisplay: {
            bg: "#fff",
          },
        },
        submitIcon: "#b91010",
        submitImageIcon: "#b91010",
      },
      borderStyle: {
        topLeft: "0px",
        topRight: "0px",
        bottomLeft: "0px",
        bottomRight: "0px",
      },
      hideCloseButton: false,
      submitIconSize: 25,
      closeButtonIconSize: "20px",
      asyncMode: true,
      toLoad: [],
      scrollBottom: {
        messageSent: true,
        messageReceived: true,
      },
      displayHeader: true,
      profilePictureConfig: {
        others: true,
        myself: true,
        styles: {
          width: "30px",
          height: "30px",
          borderRadius: "50%",
        },
      },
      timestampConfig: {
        format: "dd/MM/yyyy HH:mm",
        relative: false,
      },

      linkOptions: {
        myself: {
          className: "myLinkClass",
          format: formatUrl,
        },
        others: {
          className: "othersLinkClass",
          format: formatUrl,
        },
      },
    };
  },
  computed: {
    // ...mapGetters([

    //   'mostrarInput',
    //   'iniciarReclamo',
    //   'selectedProduct',
    //   'messages',
    // ]),

    reclamoBandera: function () {
      return this.datos.sentMessages > 0 ? true : false;
    },
    reclamo: function () {
      return this.datos.reclamo;
    },
  },
  mounted() {
    EventBus.$on("setReclamo", (reclamo) => {
      console.log("EventBusChat", reclamo);
    });
    console.log(
      "FECHA VTEX",
      this.$date(this.datos.vtex_fecha.date).format("DD/MM/YYYY HH:mm")
    );
    console.log("IMPORTE", this.datos.importe / 100);

    if (
      [10, 8, 2, 5, 9, 6].includes(this.datos.motivo_id) &&
      this.iniciarReclamo
    ) {
      // this.vuexIsloading()
      setTimeout(() => {
        this.onMessageSubmitV2({
          message: this.datos.datos_reclamo[0].motivo_id,
          reabrir: false,
        });
      }, 100);
    }
  },
  created() {
    // console.log('abircharventada', this.datos);
    this.getMensajes();
    //  if(this.datos.datos_reclamo[0].motivo_id == 10) console.log('DEVOLUCIÓN DE DINERO')
    //  EventBus.$emit('numero_reclamo', this.numberCase);
    //  EventBus.$on('inicio-chat', (val) => {
    //    console.log('control getMensaje', val)
    //    this.inicio = val
    //  });
    //  setTimeout( () => {
    //   if(this.datos.sentMessages != 0) {
    //     console.log('datos inicio getMensajes', this.datos.inicio);
    //     this.getMensajes()
    //   } else {
    //     this.datos.inicio = false
    //     console.log('datos inicio ');

    //   }
    //  }, 500)

    // this.inicio = false;
    // EventBus.$emit('reclamoBandera', this.reclamoBandera);
    // console.log('datos en commentSection', this.datos);
    // console.log('motivo-id', this.datos.datos_reclamo[0].motivo_id);

    // EventBus.$on('reAbrirMsj', (val) => {
    //   console.log('RE ABRIR MENSAJE', val);
    //   this.onMessageSubmitV2({reabrir: val});
    // });

    // EventBus.$on('loading-reclamo', (val) => {
    //   this.loadingReclamo = val
    // });

    const recaptcha = this.$recaptchaInstance;

    recaptcha.hideBadge();

    // EventBus.$on('habilitarChat', (opt) => {
    //   console.log('opt', opt);
    //   setTimeout(() => {
    //     if(opt){
    //       this.mostrarInput = 'X';
    //       this.getMensajes();
    //     } else {
    //       this.mostrarInput = 'C';
    //       this.getMensajes();
    //     }
    //   }, 2000);

    // });

    window.scrollTo(0, 0);
  },
  methods: {
    getClase(origen)
    {
  let clase = 'comment user-comment';
      switch (origen) {
        case 'C':
          clase = 'comment user-comment';
          break;
           case 'F':
          clase = 'comment author-comment';
          break;
           case 'A':
          clase = 'comment bot-comment';
          break;
      
       
      }
      return clase;
    },
    stringToHTML(str) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(str, "text/html");
      return doc.body;
    },
    obtenerCase() {
      if (!this.numberCase < 0) {
        this.nuevo = false;
        setTimeout(() => {
          HTTP.post("/updateNumberCase", {
            fo_pv_cab: this.datos.datos_reclamo[0].id,
            id_wc: this.datos.datos_reclamo ? this.datos.datos_reclamo[0].id_wc : 0,
          }).then((res) => {
            this.numberCase = res.data > 0 ? res.data : -1;
            this.nuevo = res.data > 0 ? true : false;
            if (!res.data) {
              this.obtenerCase();
            }
          });
        }, 6000);
      }
    },
    anularBoton() {
      return !this.nuevo;
    },
    reAbrirReclamo() {
      EventBus.$emit("reabrirReclamo");
    },
    chatDetealles() {
      EventBus.$emit("isMobile", false);
      return false;
    },
    prueba() {
      console.log("entro");
    },
    guardarMensaje({ content, reclamo }) {
      HTTP.post("/guardarMensaje", { mensaje: content, reclamo: reclamo })
        .then((res) => console.log("mensaje guardado?", res))
        .catch((err) => console.log("error catch:", err));
    },

    /* Método para enviar un mensaje automático al cliente */
    getAutomaticos() {
      let aux = {
        content:
          "Nuevo reclamo generado (#" +
          this.numberCase +
          ")<br>" +
          AUTOMATIC_MESSAGE,
        myself: false,
        participantId: -1,
        timestamp: new Date().toISOString(),
        type: "text",
        uploaded: true,
        viewed: true,
        origen: "F",
      };
      setTimeout(() => {
        if (this.messages.filter((f) => f.participantId == -1).length < 1) {
          this.vuexAddMensaje({ mensaje: aux });
          this.guardarMensaje({
            content:
              "Nuevo reclamo generado (#" +
              this.numberCase +
              ")<br>" +
              AUTOMATIC_MESSAGE,
            reclamo: this.datos.reclamo,
          });
          EventBus.$emit("numero_reclamo", this.numberCase);
        }
        console.log(
          "automaticos",
          this.messages.filter((f) => f.participantId == -1)
        );
      }, 1500);
    },

    reabrirReclamo() {
      EventBus.$emit("reabrirReclamo", true);
    },

    /* Método para cargar los mensajes que se encuentran en la DB local */
    getMensajes() {
      this.textLoading = "Cargando mensajes...";
      this.colorBotones = "info";
      // this.messages    = []
      this.messages = [];
      this.loading = true;
      let vtex_id = this.datos.vtex_id;
      EventBus.$emit("loading-chat", this.loading);

      HTTP.post("/getMensajes", {
        vtex_id: vtex_id,
        origen: this.origen,
        reclamo: this.datos.datos_reclamo ? this.datos.datos_reclamo[0].id_wc:0,
      })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
          if (res.data.length > 0) {
            
            res.data.forEach((element) => {
              let aux = {
                content: element.origen != 'C' ? this.validarJSON(element.mensaje) : element.mensaje,
                myself: this.setOrigen(element.origen),
                origen: element.origen,
                participantId: element.origen == "A" ? -1 : this.reclamo,
                timestamp: new Date(element.fecha.date).toISOString(),
                type: element.url ? "image" : "text",
                uploaded: true,
                preview: element.url ? FILES_PATH + element.url : "",
                src: element.url ? FILES_PATH + element.url : "",
                viewed: element.estado ? true : false,
                isMail: element.isMail ? true : false,
              };
              setTimeout(() => {
                 this.messages.push(aux);
              }, 10);
             
            });
          }
          console.log(this.messages);
        })
        .catch((err) => {
          this.$alert(
            "No se pudo recuperar el historial de mensajes " + err,
            "Error",
            {
              confirmButtonText: "Aceptar",
              callback: () => {
                window.location.reload();
              },
            }
          );
        });
    },
  validarJSON(mensaje)
  {
   
      try {
          JSON.parse(mensaje);
        
          return "";
            // return mensaje;

        }
        catch (error) {
            return mensaje;
        }
     
  },
    setOrigen(origen) {
      if (this.$route.name == "admin" && origen == "A") return false;
      if (this.$route.name == "admin" && origen == "C") return false;
      if (this.$route.name == "admin" && origen == "F") return true;
      if (this.$route.name != "admin" && origen == "A") return false;
      if (this.$route.name != "admin" && origen == "C") return true;
      if (this.$route.name != "admin" && origen == "F") return false;
    },

    loadMoreMessages(resolve) {
      setTimeout(() => {
        resolve(this.toLoad); //We end the loading state and add the messages
        //Make sure the loaded messages are also added to our local messages copy or they will be lost
        this.messages.unshift(...this.toLoad);
        this.toLoad = [];
      }, 1000);
    },

    //? Método para enviar mensajes a webcentrix V2
    async onMessageSubmitV2({ message = null, reabrir = null }) {
        await this.$recaptchaLoaded();
      const token = await this.$recaptcha("enviarMensaje");
      this.datos.sentMessages = this.datos.datos_reclamo
        ? this.datos.datos_reclamo[0].total_mensajes
        : 0;
      if (this.datos.inicio) this.datos.inicio = false;
      if (message != null && reabrir == null) message.content = "Envio el siguiente archivo";

     


      if (token) {
        if (message == null && reabrir == null) {
        message = {};
        message.content = this.message;
        if (message.content.trim().length > 0) {
          this.messages.push({
            content: message.content,
            myself: true,
            timestamp: new Date().toISOString(),
            type: "text",
            origen: "C",
            preview: false,
          });
          console.log("entro 1", message);
          this.message = "";
        } else {
          this.message = "";
          console.log("messageeee", message.content.trim().length);
          return;
        }
      }
    
    
    

      message.vtex_id = this.datos.vtex_id;
      message.sentMessages = reabrir == true ? -1 : this.datos.sentMessages;
      message.reclamo = this.reclamo || ((this.datos.datos_reclamo && this.datos.datos_reclamo[0] )? this.datos.datos_reclamo[0].id : 0);
      message.subject = this.datos.datos_reclamo
        ? this.datos.datos_reclamo[0].motivo
        : "Quiero realizar una consulta relacionada a este compra";
      message.motivoId = this.datos.datos_reclamo
        ? this.datos.datos_reclamo[0].motivo_id
        : 1;
      message.wcTipo = this.datos.datos_reclamo
        ? this.datos.datos_reclamo[0].wc_tipo
        : "";
      message.id_wc = this.datos.datos_reclamo
        ? this.datos.datos_reclamo[0].id_wc
        : "";
         message.group_id = this.datos.datos_reclamo
        ? this.datos.datos_reclamo[0].group_id
        : 0;
          message.wc_status = this.datos.datos_reclamo
        ? this.datos.datos_reclamo[0].wc_status
        : "";
      message.email = this.datos.mail_d ? this.datos.mail_d : "";
      message.nombre = this.datos.nombre + " " + this.datos.apellido;
      // message.nombre        = this.datos['apellido'] + ' ' + this.datos['nombre'];
      message.telefono = this.datos.telefono;
        message.dni = this.datos.dni;
        message.envio = this.datos.envio;
      message.content =
        reabrir == true
          ? "El cliente re abrio el reclamo número " + this.datosAux.idwc
          : message.content;

      message.fechaVtex = this.$date(this.datos.vtex_fecha.date).format(
        "DD/MM/YYYY HH:mm"
      );
      message.totalOperacion = this.datos.importe / 100;
        this.nuevo = false;
        this.loading = true
        setTimeout(() => {
          HTTP.post("/setMensaje", message)
            .then((res) => {
              // console.log("message en el then", message);
              console.log("respuesta de /setMensaje", res.data);
        this.loading = false

              this.numberCase = res.data.number_case;
              this.datos.datos_reclamo = res.data.reclamo;
              this.datos.id_wc = res.data.reclamo.id;
              if (res.data.reclamo[0].total_mensajes == 1) {
                this.messages.push({
                  content:
                    "Tu consulta fue enviada con éxito. En breve nos pondremos en contacto contigo. Podrás ver el estado de tu consulta presionando el botón + Detalle del reclamo",
                  myself: false,
                  timestamp: new Date().toISOString(),
                  type: "text",
                  origen: "F",
                  preview: false,
                });
              }
              if (res.data && res.data.status && message.wc_status != 'closed') {
                message.uploaded = res.data.guardado;
                message.viewed = false;
                message.preview = res.data.url ? FILES_PATH + res.data.url : "";
                message.myself = true;
                message.type = res.data.url ? "image" : "text";
                message.timestamp = res.data.timestamp;
                message.src = res.data.url ? FILES_PATH + res.data.url : "";

                this.message = "";
              } else {
                this.$alert(
                  "No se pudo enviar el mensaje, refresque la página y reintente",
                  "No se pudo enviar el mensaje 1",
                  {
                    confirmButtonText: "Aceptar",
                    callback: () => {
                      this.getMensajes();
                    },
                  }
                );
              }
              this.nuevo = true;
            })

            .catch(() => {
              this.nuevo = true;
              this.loading = false
              this.$alert(
                "No se pudo enviar el mensaje, refresque la página y reintente 2"
              );
            });
        }, 100);
      } else {
        this.$alert(
          "Su consulta se encuentra en proceso de verificación, por favor aguarde la respuesta. CÓDIGO [009933]"
        );
      }
    },

    onClose() {
      this.visible = false;
    },

    //? Método para enviar imagen (versión vieja)
    onImageSelected(files) {
      let origen = this.$route.name == "admin" ? "F" : "C";
      var formData = new FormData();

      formData.append("content", files.message.content);
      formData.append("file", files.file);

      formData.append("participantId", files.message.participantId);
      formData.append("timestamp", files.message.timestamp);

      formData.append("origen", origen);

      //* Datos para enviar a webcentrix
      formData.append("sentMessages", this.datos.sentMessages);
      formData.append("reclamo", this.reclamo);
      formData.append("subject", this.datos["datos_reclamo"][0].motivo);
      formData.append("wcTipo", this.datos["datos_reclamo"][0].wc_tipo);
      formData.append("group_id", this.datos["datos_reclamo"][0].group_id);
      formData.append(
        "email",
        this.datos["mail_d"] ? this.datos["mail_d"] : "test@gmail.com"
      );
      formData.append(
        "nombre",
        this.datos["apellido"] + ", " + this.datos["nombre"]
      );
      formData.append("telefono", this.datos["telefono"]);
      formData.append("envio", this.datos["envio"]);
      formData.append("dni", this.datos["dni"]);
      formData.append("idwc", this.datos["datos_reclamo"][0].id_wc);

      setTimeout(() => {
        this.onMessageSubmit(formData);
      }, 150);
    },

    //? Método para enviar imagen a webcentrix
    onImageSelectedV2(res, file) {
      console.log(res);
      console.log(this.dataMensaje);
      setTimeout(() => {
         this.loading =false
      }, 250);
     
      this.subiendoImagen = false;
      this.messages.push({
        content: "image",
        myself: false,
        origen: "C",
        participantId: this.datos["vtex_id"],
        preview: window.URL.createObjectURL(file.raw),
        timestamp: new Date().toISOString(),
        uploaded: true,
        viewed: false,
      });
      //         console.log('onImageSelectedV2 file', file);
      //         console.log('onImageSelectedV2 res', res);

      //         let origen = 'C'
      //         var formData = new FormData();

      //         formData.append("content", 'image');
      //         formData.append("file"   , file.raw);

      //         formData.append("origen" , origen);

      //         //* Datos para enviar a webcentrix
      //         formData.append("sentMessages", this.datos.sentMessages);
      //         formData.append("reclamo"     , this.reclamo);
      //         formData.append("subject"     , this.datos['datos_reclamo'][0].motivo);
      //         formData.append("wcTipo"      , this.datos['datos_reclamo'][0].wc_tipo);
      //         formData.append("email"       , this.datos['mail_d'] ? this.datos['mail_d'] : 'test@gmail.com');
      //         formData.append("nombre"      , this.datos['apellido'] + ', ' + this.datos['nombre']);
      //         formData.append("telefono"    , this.datos['telefono']);
      //         formData.append("dni"         , this.datos['dni']);
      //         formData.append("idwc"        , this.datos['datos_reclamo'][0].id_wc);

      //         formData.append("vtex_id"         , this.datos['vtex_id']);
      //         formData.append("fechaVtex"       , this.$date(this.datos.vtex_fecha.date).format('DD/MM/YYYY HH:mm') );
      //         formData.append("totalOperacion"  , this.datos.importe/100);

      //         console.log('Form Data --->', formData);
      // this.dataMensaje = formData;
      //         setTimeout( () => this.onMessageSubmitV2({message: formData}) , 500 );
      //       }
    },

    //? Método para mostrar una vista previa de la imagen antes de subirla
    beforeAvatarUpload(file) {
      console.log("beforeAvatarUpload file", file);
      this.subiendoImagen = true;
      this.textLoading = "Subiendo imagen...";
      this.loading= true
      let origen = "C";
      var formData = new FormData();

      this.dataMensaje.content = "image";
      // this.dataMensaje.file"   , file.raw);

      this.dataMensaje.origen = origen;

      //* Datos para enviar a webcentrix
      this.dataMensaje.sentMessages =
        this.datos["datos_reclamo"] &&
        this.datos["datos_reclamo"][0].total_mensajes
          ? this.datos["datos_reclamo"][0].total_mensajes
          : 0;
      this.dataMensaje.reclamo = this.reclamo;
      this.dataMensaje.subject = this.datos["datos_reclamo"]
        ? this.datos["datos_reclamo"][0].motivo
        : "Quiero realizar una consulta sobre mi pedido";
      this.dataMensaje.wcTipo = this.datos["datos_reclamo"]
        ? this.datos["datos_reclamo"][0].wc_tipo
        : "";
           this.dataMensaje.group_id = this.datos["datos_reclamo"]
        ? this.datos["datos_reclamo"][0].group_id
        : 0;
      this.dataMensaje.email = this.datos["mail_d"]
        ? this.datos["mail_d"]
        : "test@gmail.com";
      this.dataMensaje.nombre =
        this.datos["apellido"] + ", " + this.datos["nombre"];
      this.dataMensaje.telefono = this.datos["telefono"];
      this.dataMensaje.envio = this.datos["envio"];
      this.dataMensaje.dni = this.datos["dni"];
      this.dataMensaje.id_wc = this.datos["datos_reclamo"]
        ? this.datos["datos_reclamo"][0].id_wc
        : 0;

      this.dataMensaje.vtex_id = this.datos["vtex_id"];
      this.dataMensaje.fechaVtex = this.$date(
        this.datos.vtex_fecha.date
      ).format("DD/MM/YYYY HH:mm");
      this.dataMensaje.totalOperacion = this.datos.importe / 100;

      if (!this.validarImg({ type: file.type })) {
        //    this.messages.push({
        //               content      : "image",
        //               myself       : false,
        //               origen       : 'C',
        //               participantId: this.datos['vtex_id'],
        //               preview      : window.URL.createObjectURL(file.raw),
        //               timestamp    : new Date().toISOString(),
        //               uploaded     : true,
        //               viewed       :  false,

        //    });
        //     this.imgBandera = false;
        //  } else {
        this.$alert(
          "La imagen solo puede ser jpg o png ",
          "Formato incorrecto",
          {
            confirmButtonText: "Aceptar",
            type: "error",
          }
        );
      }
    },
    regresar() {
      EventBus.$emit("abriChat", false);
    },
    regresarPedido() {
      EventBus.$emit("regresarAlPedido", false);
    },

    //? Método para validar que solo suba archivos con formatos png, jpg, jpeg
    validarImg({ type }) {
      const isPNG = type === "image/png";
      const isJPG = type === "image/jpg";
      const isJPEG = type === "image/jpeg";
      const isImg = isPNG || isJPG || isJPEG;
      console.log("es imagen?", isImg);
      return isImg;
    },

    onImageClicked(message) {
      window.open(message.src, "_blank");
    },
  },
};
</script>

<style lang="scss">
/* //* Estilos CSS */

.html > table > thead {
  display: none;
}
.html > table > tbody > tr {
  border: none !important;
}
.html > table > tbody > tr > td {
  display: block !important;
  background: #fff;
  border: none !important;
  border-bottom: 1px solid #f1f1f1 !important;
}
.html > table > tbody > tr > td > p {
  // display: block;
  background: #fff !important;
}
.btn-chat-opt {
  float: left;
  padding: 4px;
  margin-right: 5px;
  display: inline-block;
  margin-top: 2px;
}
.btn-chat-opt > i {
  font-size: 13.5px !important;
}
.comment-section-new {
  width: 100%;
  position: relative !important;
}

.chat-header {
  border: none;
  height: 38px;
  border-bottom: 1px solid #dcdfe6;
  background: #f5f7fa;

  color: #909399;
}

.contenido-button {
  display: inline-flex;
  flex-wrap: nowrap;
  align-content: stretch;
  justify-content: space-evenly;
  align-items: center;
}

.col-button {
  margin-top: 10px;
  margin-left: 0;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}

[class*=" el-icon-"],
[class^="el-icon-"] {
  font-family: element-icons !important;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  font-size: x-large;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.comment-section {
  list-style: none;
  // width         : 100%;
  padding: 10px 10px 30px 10px;
  height: calc(600px - 210px);
  // height        : 3000px; //chekiar con imagenes
  overflow-y: scroll;
  background: white;
  padding-bottom: 0px;
  border-right: 1px solid #e1e1e1;
  margin-top: 0;
  position: relative;
}
// .comment-section > li:first-child{
// position: fixed;
//     background-color: #ffffff;
//     z-index: 100;

//     margin-top: -10px;
//     max-width: 320px;

//     margin-left: -10px;
//     padding: 10px 0px;
// }
.comment {
  display: flex;
  border-radius: 3px;
  margin-bottom: 0px;
  flex-wrap: wrap;
}

.comment.user-comment {
  color: #808080;
}

.comment.author-comment {
  color: #60686d;
  justify-content: flex-end;
}

/* User and time info */

.comment .info {
  width: 17%;
  line-height: 1;
}

.comment.user-comment .info {
  text-align: right;
}

.comment.author-comment .info {
  order: 3;
  text-align: left;
  line-height: 1;
}

.comment .info a {
  /* User name */
  font-size: 12px;
  display: block;
  text-decoration: none;
  color: #656c71;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 9px 0px 0px 0px;
}

.comment .info span {
  /* Time */
  font-size: 10px;
  color: #9ca7af;
}
/* The user avatar */

.comment .avatar {
  width: 8%;
}

.comment.user-comment .avatar {
  padding: 10px 18px 0 3px;
}

.comment.author-comment .avatar {
  order: 2;
  padding: 10px 3px 0 18px;
}

.comment .avatar img {
  display: block;
  border-radius: 50%;
  width: 30px;
}

.comment.user-comment .avatar img {
  float: right;
}

/* The comment text */

.comment p {
  line-height: 1.5;
  padding: 10px 10px;
  padding-bottom: 10px;
  width: 50%;
  position: relative;
  word-wrap: break-word;
  color: #000;
}

.comment.user-comment p {
  background-color: #eceff1;
  border-radius: 2px;
  text-align: left;
}

.comment.author-comment p {
  background-color: #efebe9;
  border-radius: 2px;
  order: 1;
  text-align: left;
}
.comment.bot-comment p {
background-color: #fafafa;
    border-radius: 2px;
    order: 1;
    text-align: left;
    padding: 5px;
    color: #9e9e9e;
    font-size: 11px;
    margin-bottom: 10px;
}
li.comment.bot-comment {
 margin-bottom: -25px;

}
.user-comment p:after {
  content: "";
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 2px solid #caebf2;
  left: -8px;
  top: 18px;
}

.author-comment p:after {
  content: "";
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 2px solid #efefef;
  right: -8px;
  top: 18px;
}

.html p {
  padding: 0;
}
.html img {
  width: 100% !important;
  text-align: center;
  display: block;
  margin: 0 auto;
  min-height: 100px;
  max-height: 50vh;
  object-fit: contain;
  border-radius: inherit;
}

.html p:after {
  padding: 0;
  display: none;
}

.write-new textarea {
  color: #444;
  font: inherit;
  resize: none;
  outline: 0;
  border-radius: 3px 0px 0px 3px !important;
  border: 1px solid #cecece;
  background-color: #fefefe;
  box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.06);
  overflow: auto;
  // width           :100%;
  height: 80px;
  padding: 15px 20px;
  box-sizing: border-box;
  min-width: 100%;
  max-width: 100%;
  margin-bottom: 10px;
}

.write-new img {
  border-radius: 50%;
  margin-top: 15px;
}
.upload:active,
.upload:hover,
.upload:visited,
.upload:focus {
  background: #BFBE51;
  border-color: #BFBE51;
  color: #333;
}
.upload {
  box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.12);
  border-radius: 0px 3px 3px 0px !important;
  border: 0;
  color: #ffffff;
  font-weight: 500;
  cursor: pointer;
  background: #BFBE51;
  border-color: #BFBE51;
  padding: 0px 11px;
  height: 80px;
  margin-top: 0;
  transition: all 0.3s ease-in-out;
  font-weight: bold !important;
  font-family: 'Montserrat', sans-serif !important;
}
button > span {
  font-family: 'Montserrat', sans-serif !important;
}

#botones {
  font-family: 'Montserrat', sans-serif !important;
}
.el-button--danger.is-active,
.el-button--danger:focus {
  background: #dd6161;
  border-color: #dd6161;
  color: #fff;
}
.upload i {
  font-size: 13.5px;
  margin-left: 5px;
  font-weight: bold;
}

.upload span {
  font-size: 13.5px;
}

.write-new button {
  box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  border: 0;
  color: #ffffff;
  font-weight: 500;
  cursor: pointer;
}
.write-new button i {
  font-size: 16px;
}

/* Responsive styles */

/* Make the paragraph in the comments take up the whole width,
    forcing the avatar and user info to wrap to the next line*/
.comment p {
  width: 100%;
}

/* Reverse the order of elements in the user comments,
    so that the avatar and info appear after the text. */
.comment.user-comment .info {
  order: 3;
  text-align: left;
}

.comment.user-comment .avatar {
  order: 2;
}

.comment.user-comment p {
  order: 1;
}
/* Reverse the order of elements in the user comments,
    so that the avatar and info appear after the text. */
.comment.author-comment .info {
  order: 2;
  text-align: left;
}

.comment.author-comment .avatar {
  order: 3;
}

.comment.author-comment p {
  order: 1;
}

/* Align toward the beginning of the container (to the left)
    all the elements inside the author comments. */
.comment.author-comment {
  justify-content: flex-end;
}

.comment .info {
  width: auto;
}

.comment .info a {
  padding-top: 15px;
}

.comment.user-comment .avatar {
  padding: 15px 10px 0 18px;
  width: auto;
}
.comment.author-comment .avatar {
  padding: 15px 10px 18px 10px;
  width: auto;
}

.comment.author-comment p:after {
  width: 12px;
  height: 12px;
  top: initial;
  right: 28px;
  bottom: -6px;
}

.comment.user-comment p:after {
  width: 12px;
  height: 12px;
  top: initial;
  left: 28px;
  bottom: -6px;
}

.write-new {
  width: 100%;
  padding: 20px 10px;
  box-sizing: border-box;
  position: absolute;
  background-color: white;
  top: 99.8%;
  left: -2px;
  border-left: 2px solid #ddd;
  border-top: 1px solid #f1f1f1;
  min-width: 320px;
}
.table-detalles {
  padding: 30px 30px;
  height: calc(100vh - 200px);
}
.table-detalles table {
  text-align: left;
  padding: 10px;
  margin-top: 20px;
}
@media screen and (max-width: 768px) {
  .comment-section {
    height: calc(100vh - 200px);
    z-index: 1000;
  }
}
</style>
